import { render, staticRenderFns } from "./AppNavigationMenu.vue?vue&type=template&id=49f80672"
import script from "./AppNavigationMenu.vue?vue&type=script&lang=js"
export * from "./AppNavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationMenu.vue?vue&type=style&index=0&id=49f80672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports